import React, { FC } from 'react'

import { Tooltip, Txt } from 'src/components/atoms'

import { RequireOne } from 'src/types'

type DetailType = RequireOne<{
  detailText?: string | number | null
  detailChildren?: React.ReactNode
}>

type Props = {
  title: string
  tooltipContent?: React.ReactNode
  className?: string
} & DetailType

export const ProjectDetailItem: FC<Props> = ({
  title,
  tooltipContent,
  detailText,
  detailChildren,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-grid tw-gap-r-3">
        <div>
          {tooltipContent ? (
            <Tooltip content={tooltipContent} placement="top">
              <Txt className="tw-text-standardText-secondary">{title}</Txt>
            </Tooltip>
          ) : (
            <Txt className="tw-text-standardText-secondary">{title}</Txt>
          )}
        </div>
        <div className="tw-min-h-[1.79rem]">
          {detailText === undefined ? (
            detailChildren
          ) : (
            <Txt sizeType="l" className="tw-break-all">
              {detailText || '-'}
            </Txt>
          )}
        </div>
      </div>
    </div>
  )
}
